import React from 'react';
import DataAccessContentWrapper from 'users/containers/Organization/Roles/rolesExpandedRowComponents/DataAccess/DataAccessContentWrapper';

const DataAccessTab = ({ row }) => {
  return (
    <DataAccessContentWrapper
      isViewOnly={true}
      roleId={row.id}
      isCreateEditMode={false}
      isRoleEditable={row?.editable}
    />
  );
};


export default DataAccessTab;
